import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { openNotification } from 'src/components/helpers/notification';
import ax from 'src/store/config';


const initialState = {
    passagesList: null,
    passagesLoading: false,
    photoList: null,
    photoLoading: false,
};

export const getPhoto = createAsyncThunk(
  "passages/getPhoto",
  async (payload) => {
    try {
      const { data } = await ax.get("/api/admin/directory/passagePhoto", {
        params: payload,
        responseType: 'blob'
      })
      const imageUrl = URL.createObjectURL(data)
      return imageUrl
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const passagesAction = createAsyncThunk('passagesAction', async (payload, { dispatch }) => {
    dispatch(setPassagesLoading(true))
    try {
        let data;
        const url = '/api/admin/directory/passages';
        switch (payload.flag) {
            case 'get':
                ({ data } = await ax.get(url, { params: payload.value }))
                data && dispatch(setPassagesLoading(false))
                return data
            default:
                break;
        }
    } catch (error) {
        dispatch(setPassagesLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

export const getPassagesTypes = createAsyncThunk('getPassagesTypes', async (payload, { dispatch }) => {
    dispatch(setPassagesLoading(true))
    try {
        let data;
        const url = '/api/admin/directory/getPassagesTypes';
        ({ data } = await ax.get(url, { params: payload.value }))
        data && dispatch(setPassagesLoading(false))

        return data
    } catch (error) {
        dispatch(setPassagesLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

const PassagesSlice = createSlice({
    name: 'passages',
    initialState,
    reducers: {
        setPassagesLoading: (state, action) => {
            state.passagesLoading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(passagesAction.fulfilled, (state, action) => {
            state.passagesList = action.payload
        })
         builder.addCase(getPhoto.pending, (state) => {
      state.photoLoading = true
    })
    builder.addCase(getPhoto.fulfilled, (state, action) => {
      state.photoList = action.payload
    })
    builder.addCase(getPhoto.rejected, (state, action) => {
      state.photoLoading = false
    })
  },
    });

export const { setPassagesLoading } = PassagesSlice.actions;

export default PassagesSlice.reducer